import AccountsModel from '../../models/account/AccountModel.js';

const AccountCollection = Backbone.Collection.extend({

  model: AccountsModel,

  initialize(options) {
    _.extend(this, options);

    this.lastPage = null;

    this.serviceTitle = window.lookup('Social');

    if (this.hasOwnProperty('myservices') && !this.myservices) {
      this.comparator = function (model) {
        return model.get('description');
      };
    }
  },

  sync(method, collection, options) {
    const params = _.omit(
      $.extend(true, {}, options),
      ['parse', 'success', 'silent', 'reset', 'remove', 'error', 'refreshCache', 'parse', 'isSharedMode'],
    );
    const cache = new Cache();
    const cacheDurationMinutes = 15;
    const defer = $.Deferred();

    options.reset = (options.reset === undefined ? true : options.reset);
    options.refreshCache = options.refreshCache || false;

    // process cache key
    const key = this.processCacheKey(params, options);

    if (cache.read(key) === null || options.refreshCache) {
      this.processFetchServices(params, options, defer, cache, cacheDurationMinutes, key);
    } else {
      this.processCacheServices(options, cache, key, defer);
    }

    const promise = defer.promise();
    return promise;
  },

  processFetchServices(params, options, defer, cache, cacheDurationMinutes, key) {
    if (options.isSharedMode) {
      Sendible.Connect.getSharedServicesList(window.appConfig.applicationId, params, _.bind(function (data) {
        this.lastPage = data.pageCount;

        options.success(data.shared_with_me);
        defer.resolve(data.accounts);
        cache.store(key, JSON.stringify(data), null, null, cacheDurationMinutes);
      }, this), (data) => {
        if (options.error) options.error(data.error.message);
        defer.reject(data);
      });
    } else {
      Sendible.Connect.getServicesList(window.appConfig.applicationId, params, _.bind(function (data) {
        this.lastPage = data.pageCount;

        options.success(data.accounts);
        defer.resolve(data.accounts);
        cache.store(key, JSON.stringify(data), null, null, cacheDurationMinutes);
      }, this), (data) => {
        if (options.error) options.error(data.error.message);
        defer.reject(data);
      });
    }
  },

  processCacheServices(options, cache, key, defer) {
    const _this = this;
    let data;

    setTimeout(() => {
      data = JSON.parse(cache.read(key));
      _this.lastPage = data.pageCount;

      if (options.isSharedMode) {
        options.success(data.shared_with_me);
        defer.resolve(data);
      } else {
        options.success(data.accounts);
        defer.resolve(data);
      }
    }, 0);
  },

  updateCache() {
    const cache = new Cache();

    cache.removeLike('GetServices_');

    cache.removeLike('_inbox_services');

    this.trigger('cacheUpdated');
  },

  processCacheKey(params, options) {
    let key = 'GetServices_';
    const keyObjects = $.extend(true, {}, options);
    const { username } = loginContext.getCurrentDetails();
    /* eslint-disable */
    if (keyObjects.hasOwnProperty('page')) keyObjects.page = keyObjects.page;
    if (keyObjects.hasOwnProperty('per_page')) keyObjects.per_page = keyObjects.per_page;
    if (keyObjects.hasOwnProperty('filter')) keyObjects.filter = keyObjects.filter.replace(/ /g, '');
    if (keyObjects.hasOwnProperty('service_id')) keyObjects.service_id = keyObjects.service_id;
    if (keyObjects.hasOwnProperty('disconnected_only')) keyObjects.disconnected_only = keyObjects.disconnected_only;
    /* eslint-enable */
    key += (username) ? `${username}_` : '';
    key += (keyObjects.hasOwnProperty('page')) ? `${keyObjects.page}_` : '';
    key += (keyObjects.hasOwnProperty('per_page')) ? `${keyObjects.per_page}_` : '';
    key += (keyObjects.hasOwnProperty('filter')) ? `${keyObjects.filter}_` : '';
    key += (keyObjects.hasOwnProperty('service_id')) ? `${keyObjects.service_id}_` : '';
    key += (keyObjects.hasOwnProperty('disconnected_only')) ? `${keyObjects.disconnected_only}_` : '';
    key += (options.isSharedMode) ? 'isSharedMode ' : ' ';

    key = key.substr(0, key.length - 1);

    return key;
  },

  processPages(storePage, basePage) {
    const pages = [];
    let row = [];
    const array = [];
    let pageNumber = null;
    const { pageLength } = this;
    const { rowLength } = this;
    const $pages = this.view.$el.find(this.pageListEl);

    // set page number
    if ($pages.length === 0) pageNumber = this.view.currentPage;
    if ($pages.length > 0) pageNumber = $(_.first($pages)).data('page-number');

    // Loop through collection splitting it by page length (pages)
    for (let pageIndex = 0; pageIndex < this.models.length; pageIndex += pageLength) {
      // add models in page rage to row
      pages.push(this.models.slice(pageIndex, pageIndex + pageLength));
    }

    // Loop each "page", splitting it into chunks (rows)
    for (let pageIndex = 0; pageIndex < pages.length; pageIndex++) {
      // Reset the row array
      row = [];

      for (let rowIndex = 0; rowIndex < pages[pageIndex].length; rowIndex += rowLength) {
        // add models to chunk
        row.push(pages[pageIndex].slice(rowIndex, rowIndex + rowLength));

        if ((storePage && typeof basePage === 'number') && (pageIndex === (pages.length - 1))) {
          pages[pageIndex].slice(rowIndex, rowIndex + rowLength)[0].set('pageNumber', basePage);
        }
      }

      // add page meta data
      row.push({ pageNumber: (pageNumber + pageIndex) });

      // add row to array
      array[pageIndex] = row;

      if (storePage) {
        basePage++;
      }
    }

    // return
    return array;
  },

});

export default AccountCollection;
